import { UserBooking } from '../../user-bookings/schemas'
import { UserCanAdd } from './UserCanAdd'

export class UserNoTokenCanAdd extends UserCanAdd {
  check(userBookings: UserBooking[], campsiteSlug: string) {
    const bookings = this.match(userBookings, campsiteSlug).sort((a, b) =>
      b.depart > a.depart ? -1 : 1,
    )
    return bookings[0]
  }

  private match(bookings: UserBooking[], campsiteSlug: string) {
    const filtered = bookings.filter((booking) =>
      this.bookingValid(booking, campsiteSlug),
    )
    if (filtered.length === 0) {
      throw new Error('already_reviewed_or_cutoff_limit_exceeded')
    }
    return filtered
  }

  private bookingValid(booking: UserBooking, campsiteSlug: string) {
    return booking.campsite.slug === campsiteSlug && booking.canReview
  }
}
